import {
  ICON_NAME_PREMIUM_PARTNER, ICON_NAME_MAIN_MENU, ICON_NAME_ARTIST, ICON_NAME_VIP, ICON_NAME_NEWS, ICON_NAME_FANBOX, ICON_NAME_CLUB, ICON_NAME_STUDIOS,
  ICON_NAME_PROMOTION, ICON_NAME_TEAM, ICON_NAME_EVENTS, ICON_NAME_OPPONENTS, ICON_NAME_SETTINGS, ICON_NAME_MEMBERS,
  ICON_NAME_LEGAL, ICON_NAME_BANNER, ICON_NAME_SHOP, ICON_NAME_FORUM, ICON_NAME_FAN_FEED, ICON_NAME_VOTE, ICON_NAME_WAY_FINDER,
  ICON_NAME_COMPETITION,
  ICON_NAME_STREAM, ICON_NAME_MICROPHONE, ICON_NAME_DASHBOARD, ICON_NAME_VIEW_EYE} from './constants';

import IconDelete from './IconDelete';
import IconEdit from './IconEdit';
import IconMembers from './IconMembers';
import IconNews from './IconNews';
import IconClub from './IconClub';
import IconStudios from './IconStudios';
import IconArtist from './IconArtist';
import IconFanBox from './IconFanBox';
import IconFanFeed from './IconFanFeed';
import IconEvents from './IconEvents';
import IconCompetitions from './IconCompetitions';
import IconVote from './IconVote';
import IconOpponents from './IconOpponents';
import IconTeam from './IconTeam';
import IconForum from './IconForum';
import IconLegal from './IconLegal';
import IconPromo from './IconPromo';
import IconSettings from './IconSettings';
import IconShop from './IconShop';
import IconVipStone from './IconVipStone';
import IconBanner from './IconBanner';
import IconStream from './IconStream';
import IconPremiumPartner from './IconPremiumPartner';
import IconMainMenu from './IconMainMenu';
import IconWayFinder from './IconWayFinder';
import IconMicrophone from './IconMicrophone';
import IconDashboard from './IconDashboard';
import IconViewEye from './IconViewEye';

// import IconLiveLogo from './IconLiveLogo';

export {IconNews, IconDelete, IconEdit, IconMembers, IconViewEye};

export function iconFactory(name) {
  switch (name) {
    case ICON_NAME_PREMIUM_PARTNER:
      return IconPremiumPartner;
    case ICON_NAME_MAIN_MENU:
      return IconMainMenu;
    case ICON_NAME_ARTIST:
      return IconArtist;
    case ICON_NAME_NEWS:
      return IconNews;
    case ICON_NAME_VIP:
      return IconVipStone;
    case ICON_NAME_FANBOX:
      return IconFanBox;
    case ICON_NAME_FAN_FEED:
      return IconFanFeed;
    case ICON_NAME_CLUB:
      return IconClub;
    case ICON_NAME_STUDIOS:
      return IconStudios;
    case ICON_NAME_VOTE:
      return IconVote;
    case ICON_NAME_PROMOTION:
      return IconPromo;
    case ICON_NAME_TEAM:
      return IconTeam;
    case ICON_NAME_FORUM:
      return IconForum;
    case ICON_NAME_EVENTS:
      return IconEvents;
    case ICON_NAME_COMPETITION:
      return IconCompetitions;
      case ICON_NAME_OPPONENTS:
      return IconOpponents;
    case ICON_NAME_SETTINGS:
      return IconSettings;
    case ICON_NAME_MEMBERS:
      return IconMembers;
    case ICON_NAME_LEGAL:
      return IconLegal;
    case ICON_NAME_BANNER:
      return IconBanner;
    case ICON_NAME_SHOP:
      return IconShop;
    case ICON_NAME_STREAM:
      return IconStream;
    case ICON_NAME_WAY_FINDER:
      return IconWayFinder;
    case ICON_NAME_MICROPHONE:
      return IconMicrophone;
    case ICON_NAME_DASHBOARD:
      return IconDashboard;
    case ICON_NAME_VIEW_EYE:
      return IconViewEye;
  }
}



// WEBPACK FOOTER //
// ./src/components/Icons/index.js